import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "../TemplateManager.scss";

export const Smu08 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [videoId, setVideoId] = useState("");

  /**
   * Updates the component state with the content of the selected slide in Smu08.js.
   *
   * This `useEffect` hook is triggered whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's title, description, and video ID.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the slide's content title.
   * - Sets the `description` state with the slide's content description, where newline characters (`\n`) are replaced with `<br />` HTML tags for proper web formatting.
   * - Sets the `videoId` state with the slide's content video ID.
   *
   * This ensures that the component reflects the content of the currently selected slide, displaying the title,
   * formatted description, and video ID in a user-friendly format. This is crucial for maintaining user engagement
   * and providing a visually appealing and informative interface.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setDescription(slide.content.description?.replace(/\n/g, "<br />"));
      setVideoId(slide.content.video_id);
    }
  }, [slideId]);

  return (
    <div className="column">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <p
        className="show-slide__text"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="row">
        <iframe
          width="100%"
          height="500"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
      </div>
    </div>
  );
});
